import React from 'react';

export const MexaIcon = ({ className = 'w-14 h-14', ...props }) => (
  <img
    src="/images/mexa_icon.png"
    alt="Mexamedico Icon"
    className={`object-contain ${className}`}
    {...props}
  />
);

const MexaLoader = ({ size = 'md', className = '', text = '', fullPage = false, inline = false }) => {
  const sizeMap = {
    sm: 'w-10 h-10',
    md: 'w-20 h-20',
    lg: 'w-28 h-28',
    xl: 'w-40 h-40',
  };

  const textSizeMap = {
    sm: 'text-sm',
    md: 'text-lg',
    lg: 'text-2xl',
    xl: 'text-3xl',
  };

  const iconSize = sizeMap[size] || sizeMap.md;
  const brandTextSize = textSizeMap[size] || textSizeMap.md;

  const loaderContent = (
    <>
      <style>{`
        @keyframes mexaLogoPulse {
          0%, 100% {
            transform: scale(0.96);
            opacity: 0.88;
          }
          50% {
            transform: scale(1.04);
            opacity: 1;
            filter: drop-shadow(0 6px 16px rgba(0, 178, 169, 0.3));
          }
        }
        .animate-mexa-pulse {
          animation: mexaLogoPulse 1.8s ease-in-out infinite;
        }
      `}</style>
      <div className={`flex flex-col items-center justify-center gap-2 ${className}`}>
        <div className="relative flex flex-col items-center justify-center">
          {/* Brand Icon PNG & Text with smooth splash-screen pulse animation */}
          <div className="relative z-10 flex flex-col items-center animate-mexa-pulse">
            <img
              src="/images/mexa_icon.png"
              alt="Loading..."
              className={`${iconSize} object-contain`}
            />
          </div>
        </div>

        {text && (
          <span className="text-sm font-semibold text-slate-500 tracking-wide animate-pulse text-center">
            {text}
          </span>
        )}
      </div>
    </>
  );

  if (fullPage) {
    return (
      <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white/90 backdrop-blur-sm w-screen h-screen">
        {loaderContent}
      </div>
    );
  }

  if (inline) {
    return loaderContent;
  }

  return (
    <div className="w-full flex-1 flex flex-col items-center justify-center min-h-[60vh] py-12 px-4 my-auto self-center justify-self-center">
      {loaderContent}
    </div>
  );
};

export default MexaLoader;
